import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {importRatePlan} from '../../../actions/adminAction/importExportRatePlanAction';
import { notify } from '../../../util/notifications';

class ImportRatePlan extends Component {
  constructor(props) {
    super(props);
    this.state = {
      file: null,
      inputFileRef: React.createRef(),
    };
  }

  onFileSubmit = (file, inputFileRef) => {
    if (file) {
      this.props.dispatch(importRatePlan(file, inputFileRef));
        notify.createNotification('success', 'Account rate plan imported successfully', this.props.refNotify);  
        window.location.reload();
    } else {
      this.props.notify.createNotification('error', 'Please select (.xls/.xlsx) file', this.props.refNotify);
    }
  }

  render() {
    return (
      <Fragment>
        <div className='row'>
          <div className='col-md-12'>
            <form>
              <div className="form-row">
                <div className="form-group col-md-12">
                  <div className="form-group">
                    <label htmlFor="ratePlanUpload">You can Add/update Rate Plans using excel(.xls, .xlsx) file. Upload it to proceed</label>
                    <div className='row'>
                      <div className='col-md-10'>
                        <input type="file" className="form-control-file" ref={this.state.inputFileRef} id="ratePlanUpload"
                          accept=".xls,.xlsx"
                          onChange={(e) => {
                            const file = e.target.files[0];
                            if (file) {
                              this.setState({ file });
                            }
                          }}

                        />
                      </div>
                      <div className='col-md-2'>
                        <button type="button" className='btn btn-primary' style={{ marginLeft: '-10px', marginBottom: '-30px' }}
                          onClick={(e) => {
                            e.preventDefault();
                            if (this.state.file) {
                              this.onFileSubmit(this.state.file, this.state.inputFileRef);
                                this.setState({ file: null, inputFileRef: React.createRef() }); 
                            } else {
                              this.props.notify.createNotification('error', 'Please select (.xls/.xlsx) file', this.props.refNotify);
                            }  
                          }}>
                          Proceed
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </Fragment>
    );
  }
}
const mapStateToProps = (state, ownProps) => {
  return {
    authInfo: state.authInfo,
    refNotify: state.refNotify,
    importRatePlan: state.importRatePlan
  };
};
export default withRouter(connect(mapStateToProps)(ImportRatePlan));